import { render, staticRenderFns } from "./modalHistoryCanjes_managerMarket.vue?vue&type=template&id=4d2b30d8&scoped=true"
import script from "./modalHistoryCanjes_managerMarket.vue?vue&type=script&lang=js"
export * from "./modalHistoryCanjes_managerMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b30d8",
  null
  
)

export default component.exports